"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagesMapSymbol = exports.NavigationInfoSymbol = exports.SamePageUrlChangeListenerSymbol = exports.CurrentRouteInfoSymbol = void 0;
exports.CurrentRouteInfoSymbol = Symbol('CurrentRouteInfo');
exports.SamePageUrlChangeListenerSymbol = Symbol('SamePageUrlChangeListener');
exports.NavigationInfoSymbol = Symbol('NavigationInfo');
exports.PagesMapSymbol = Symbol('PagesMap');
//# sourceMappingURL=router.js.map